import { render, staticRenderFns } from "./ItemProductCard.vue?vue&type=template&id=52c0e5bd&scoped=true&lang=pug&"
import script from "./ItemProductCard.vue?vue&type=script&lang=js&"
export * from "./ItemProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ItemProductCard.vue?vue&type=style&index=0&id=52c0e5bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c0e5bd",
  null
  
)

export default component.exports